/** @format */
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Box } from "@mui/material";
import { Navigate, Outlet, useParams } from "react-router-dom";
import { useIsLogin } from "../Hooks/useIsLogin";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

export default function MainLayout() {
  const { i18n, t } = useTranslation();
  const { lang } = useParams(); // 👈 extract lang from URL

  useEffect(() => {
    const supportedLangs = ['en', 'fa'];
    const cookieLang = document.cookie
      .split('; ')
      .find(row => row.startsWith('i18next='))
      ?.split('=')[1];
  
    if (!lang && cookieLang && supportedLangs.includes(cookieLang)) {
      i18n.changeLanguage(cookieLang);
      document.cookie = `i18next=${lang}; path=/; domain=.copysa.ir; max-age=31536000`;
    }
  }, [lang, i18n]);

  const isRTL = (lang) => ["fa"].includes(lang);
  const direction = isRTL(i18n.language) ? "rtl" : "ltr";

  const [loading, isLogin] = useIsLogin();

  if (loading) return <h1 className="text-center text-3xl mt-8">{t("loading.wait")}</h1>;

  if (!isLogin) {
    window.location.replace("https://app.copysa.ir/");
    return null;
  }
  return (
    <Box display="flex" flexDirection={ "row"}>
    <Sidebar />
    <Box display="flex" flexDirection="column" flexGrow={1} overflow="auto">
      <Box position="sticky" top="0" zIndex={2}>
        <Header />
      </Box>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
          overflow: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  </Box>
  );
}
